import { isAxiosError } from 'axios';

/**
 * Extract only safe fields from an error for logging. Outbound HTTP requests
 * may carry secrets (e.g. `Authorization`, `X-Figma-Token`) in
 * `config.headers`, and loggers typically serialize own-properties of the
 * error, so passing a raw AxiosError to the logger would leak credentials
 * into application logs.
 */
export function sanitizeError(error: unknown): string {
  if (isAxiosError(error)) {
    const status = error.response?.status;
    const message = (error.response?.data as { message?: string } | undefined)?.message ?? error.message;
    return status ? `HTTP ${status}: ${message}` : `No response: ${error.message}`;
  }
  return error instanceof Error ? error.message : String(error);
}
